export const NUMBER_OF_ALLOWED_SESSIONS = 40;

export const ADD_SESSION_ERROR_TEXT = `:-(\nUnfortunately, artists can't have more than ${NUMBER_OF_ALLOWED_SESSIONS} visible sessions at this time`;
